module.exports = __webpack_public_path__ + "img/filoo.7db0c3b0.jpg";